import { useTranslation } from '@wix/yoshi-flow-editor';

import { useOnlineOrdersStorage } from '../../storage';
import { useGetLayoutSize } from '../../../../components-shared/LayoutSizeProvider';
import { isLocationSelectionRequired } from '../../../../utils/fulfillmentGating';

export const useHooks = () => {
  const { t } = useTranslation();
  const { layoutSize } = useGetLayoutSize();

  const {
    dispatchesInfo,
    operations,
    currentOperation,
    isLocationSelected,
    selectedDispatchType,
    acceptingDispatchTypesByOperationId,
    openFulfillmentModal,
  } = useOnlineOrdersStorage();

  const handleClick = () => {
    if (!currentOperation) {
      return;
    }

    openFulfillmentModal({
      operations,
      currentOperation,
      dispatchesInfo,
      selectedDispatchType,
      acceptingDispatchTypesByOperationId,
      forceLocationSelection: isLocationSelectionRequired(
        operations,
        isLocationSelected,
      ),
    });
  };

  return {
    t,
    layoutSize,
    handleClick,
  };
};
